"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FoodFunction = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const LangUtil_1 = require("../../cutil/LangUtil");
const FunctionBase_1 = require("../../storyV2/function/FunctionBase");
const Meta_1 = require("../../cutil/Meta");
const FunctionUtil_1 = require("../../storyV2/function/FunctionUtil");
const RestaurantModel_1 = require("../../storyV2/model/RestaurantModel");
const SearchInfoWrapper_1 = require("../../storyV2/model/SearchInfoWrapper");
class FoodFunction extends FunctionBase_1.FunctionBase {
    constructor(brainClient, authStore, socketRestClient, locationManager) {
        super(brainClient, authStore, socketRestClient);
        this.brainClient = brainClient;
        this.authStore = authStore;
        this.socketRestClient = socketRestClient;
        this.locationManager = locationManager;
    }
    async run(input, identityInfo, variableList = [], page = 1, next = undefined) {
        const mode = "delivery";
        const locationRes = await (0, LangUtil_1.tryPromise)(this.locationManager.getLocation(false));
        if (locationRes.error || !locationRes.data) {
            const errorStr = locationRes.error.errorDescription || "Failed to get location";
            throw new Meta_1.Meta("FoodFunction error", errorStr, "");
        }
        const streamResponse = await this.socketRestClient.requestRest(topic => {
            return this.fetchRestaurantListNew(input, mode, next, locationRes.data, topic, FunctionUtil_1.FunctionUtil.createAbortUuid(identityInfo));
        }, response => {
            const result = response.data;
            const res = {
                items: result?.data?.stores ?? [],
                next: result?.data?.next,
                lat: locationRes.data.lat,
                lng: locationRes.data.lng,
                mode: mode,
            };
            const models = res.items.map(x => new RestaurantModel_1.RestaurantModel(x, locationRes.data.lat, locationRes.data.lng, result.mode));
            const pagination = new SearchInfoWrapper_1.SearchInfoPagination(1, undefined, res?.next);
            const searchInfoWrapper = new SearchInfoWrapper_1.SearchInfoWrapper(input, pagination, models);
            return new FunctionBase_1.FuncDataSource(FunctionBase_1.FuncDataSourceType.FOOD, searchInfoWrapper);
        }, "foodInterface", identityInfo);
        // const res = await this.fetchRestaurantList(input, mode, next, FunctionUtil.createAbortUuid(identityInfo));
        // // console.log("res?.next", res?.next);
        // const models = res.items.map(x => new RestaurantModel(x, res.lat, res.lng, res.mode));
        // const pagination = new SearchInfoPagination(1, undefined, res?.next);
        // const searchInfoWrapper = new SearchInfoWrapper(input, pagination, models);
        /*
        let edgeStreamResponse: FoodStreamResponse = {
          searchInfoWrapper: searchInfoWrapper,
          streamResponse: new RunStreamResponse<Map<number, RestaurantModel>>(),
        };
    
        this.fetchRestaurantInfo(mode, edgeStreamResponse).then(r => console.log("fetch restaurant info success"));
        */
        return new FunctionBase_1.FuncResponse(FunctionBase_1.FuncResponseType.FOOD, streamResponse);
    }
    async fetchRestaurantListNew(query, mode, next, locationData, topic, uuid) {
        if ((0, is_blank_1.default)(next)) {
            return this.brainClient.openAi.getRestaurantListBase(locationData.lat, locationData.lng, 0, 5, 1, true, mode, "default", query, 0, uuid, topic);
        }
        else {
            return this.brainClient.openAi.getRestaurantListByNext(next, uuid, topic);
        }
    }
    async fetchRestaurantList(query, mode, next, uuid) {
        const locationRes = await (0, LangUtil_1.tryPromise)(this.locationManager.getLocation(false));
        if (locationRes.error) {
            const errorStr = locationRes.error.errorDescription || "Failed to get location";
            throw new Meta_1.Meta("FoodFunction error", errorStr, "");
        }
        if (!locationRes.data) {
            return { items: [], next: "", lat: 0, lng: 0, mode: "" };
        }
        if ((0, is_blank_1.default)(next)) {
            const response = await this.brainClient.openAi.getRestaurantList(locationRes.data.lat, locationRes.data.lng, 0, 5, 1, true, mode, "default", query, 0, uuid);
            const result = response.data;
            return {
                items: result?.data?.stores ?? [],
                next: result?.data?.next,
                lat: locationRes.data.lat,
                lng: locationRes.data.lng,
                mode: mode,
            };
        }
        else {
            const response = await this.brainClient.openAi.getRestaurantListByNext(next, uuid);
            const result = response.data;
            return {
                items: result?.data?.stores ?? [],
                next: result?.data?.next,
                lat: locationRes.data.lat,
                lng: locationRes.data.lng,
                mode: mode,
            };
        }
    }
}
exports.FoodFunction = FoodFunction;
